<template>
    <Fragment>

        <tr @click="$emit('select-item', item.id)" v-show="visible">
            <td>
                <span>
                    <i v-for="index in level" class="level fas fa-caret-up type-indicator" :key="index"></i>

                    <a v-if="hasChildren"
                        class="show-children type-indicator"
                        href="javascript:void(0)"
                        @click.stop="showChildren = !showChildren"
                    >
                        <i v-if="!showChildren" class="fas fa-angle-down"></i>
                        <i v-else class="fas fa-angle-up"></i>
                    </a>
                    <span v-else-if="level === 0" class="type-indicator">
                        &nbsp;
                    </span>
                    
                    {{item.name}}
                </span>
            </td>
            <td><span>{{item.world}}</span></td>
            <td><span>{{item.division}}</span></td>
            <td><span>{{item.description}}</span></td>
            <td><span>{{item.version}}</span></td>
<!--            <td>-->
<!--                <span v-if="item.isLocked">-->
<!--                    <i class="fas fa-lock"></i>-->
<!--                </span>-->
<!--                <span v-else>-->
<!--                    <i class="fas fa-lock-open"></i>-->
<!--                </span>-->
<!--            </td>-->
            <td>
                <span v-if="item.isPublished">
                    <i class="fas fa-check"></i>
                </span>
            </td>
            <td>
                <button v-if="canWrite" class="btn btn-outline-secondary" @click="$emit('clone', item)">
                    <i class="far fa-clone"></i>
                </button>
                <button class="btn btn-outline-secondary" @click="$emit('edit', item)">
                    <i v-if="canWrite" class="fas fa-edit"></i>
                    <i v-else class="fas fa-eye"></i>
                </button>
                <button v-if="hasDeletePermission" class="btn btn-outline-secondary" @click="$emit('delete', item)">
                    <i class="fas fa-trash"></i>
                </button>
                <button class="btn btn-outline-secondary" @click="$emit('statistics', item)">
                    <i class="fas fa-project-diagram"></i>
                </button>
            </td>
        </tr>

        <DataRowChild v-for="child in item.children"
            :key="child.id" 
            :item="child" 
            :label="label" 
            :level="level+1"
            :visible="showChildren && child.visible"
            
            @select-item="$emit('select-item', $event)"
            @clone="$emit('clone', $event)"
            @delete="$emit('delete', $event)"
            @edit="$emit('edit', $event)"
            @statistics="$emit('statistics', $event)"
        >
        </DataRowChild>

    </Fragment>

</template>

<script>

import {Fragment} from 'vue-fragment';
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions'

export default {
    name: 'ExpandableDataTableRow',
    components: {
        DataRowChild: () => import('./ExpandableDataTableChild.vue'),
        Fragment
    },
    mixins: [permissionsMixin],
    computed: {
        hasChildren() {
            return this.item.children.length > 0;
        }
    },
    data() {
        return {
            showChildren: false
        };
    },
    watch: {
        filtered(value) {
            if(value) {
                this.showChildren = true;
            } else {
                this.showChildren = false;
            }
        }
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        level: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: true
        },
        filtered: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
    .type-indicator {
        padding-right: 5px;
    }

    .level {
        padding-left: 20px;
    }
    
    .show-children {
        //position: relative;
        //right: -150px;
        color: black
    }
</style>